// CAT Mock 3 — DILR section.
const catMock3Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: `The table below shows the revenue (in ₹ crore) and the profit margin (profit as a percentage of revenue) of the five divisions of a company in 2022 and 2023. Cost = Revenue − Profit.`,
    table: {
      columns: ["Division", "Revenue 2022", "Margin 2022", "Revenue 2023", "Margin 2023"],
      rows: [
        ["North", "120", "15%", "150", "12%"],
        ["South", "80", "25%", "96", "25%"],
        ["East", "150", "10%", "165", "16%"],
        ["West", "100", "20%", "90", "30%"],
        ["Central", "50", "8%", "99", "10%"]
      ]
    },
    question: "Which division recorded the highest percentage increase in profit from 2022 to 2023?",
    options: [
      "A. East",
      "B. West",
      "C. Central",
      "D. South"
    ],
    answer: "C"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    question: "By how much (in ₹ crore, correct to one decimal place) did the total profit of the company increase from 2022 to 2023?",
    answer: "28.3"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    question: "For how many divisions was the percentage increase in profit from 2022 to 2023 strictly greater than the percentage increase in revenue over the same period?",
    options: [
      "A. 2",
      "B. 3",
      "C. 4",
      "D. 5"
    ],
    answer: "B"
  },
  {
    id: 28,
    type: "mcq",
    setId: "di1",
    question: "Suppose that in 2024 each division's revenue grows by the same percentage as it did from 2022 to 2023, and each division's margin stays at its 2023 level. Which division would then earn the highest profit in 2024?",
    options: [
      "A. South",
      "B. East",
      "C. West",
      "D. North"
    ],
    answer: "B"
  },
  {
    id: 29,
    type: "tita",
    setId: "di1",
    question: "The cost of the West division in 2023 was what percentage of its cost in 2022? (Enter the number only.)",
    answer: "78.75"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: `Seven speakers — A, B, C, D, E, F and G — each give one talk at a conference, on seven consecutive days from Monday to Sunday, one talk per day. Each talk is on a different subject among Art, Biology, Chemistry, Drama, Economics, French and Geography.
• The Economics talk is on Monday.
• D speaks on an earlier day than A, and D's talk is on none of Biology, French or Drama.
• C speaks exactly two days after A.
• G speaks on the day immediately after C.
• B speaks on a later day than G, but not on Sunday.
• The Biology talk is on the day immediately after F's talk.
• The Geography talk is on the day immediately before the Art talk.
• The Art talk is on an earlier day than the French talk.
• Exactly two speakers speak between F and B.
• E speaks on a later day than the Art, French and Drama talks.
• The Chemistry talk is not on Saturday.
• G's talk is on neither Drama nor Chemistry.`,
    question: "Who speaks on Wednesday?",
    options: [
      "A. A",
      "B. F",
      "C. C",
      "D. G"
    ],
    answer: "B"
  },
  {
    id: 31,
    type: "mcq",
    setId: "di2",
    question: "On which subject does E speak?",
    options: [
      "A. Biology",
      "B. Drama",
      "C. Chemistry",
      "D. French"
    ],
    answer: "C"
  },
  {
    id: 32,
    type: "tita",
    setId: "di2",
    question: "How many speakers speak on days between D's talk and G's talk?",
    answer: "3"
  },
  {
    id: 33,
    type: "mcq",
    setId: "di2",
    question: "Which of the following is true?",
    options: [
      "A. B speaks on French.",
      "B. C speaks on Biology.",
      "C. A speaks on Art.",
      "D. G speaks on Thursday."
    ],
    answer: "B"
  },
  {
    id: 34,
    type: "mcq",
    setId: "di2",
    question: "Who gives the Drama talk?",
    options: [
      "A. A",
      "B. G",
      "C. B",
      "D. E"
    ],
    answer: "C"
  },
  {
    id: 35,
    type: "tita",
    setId: "di2",
    question: "If the days are numbered Monday = 1 to Sunday = 7, what is the sum of the day numbers of the Geography, Art and French talks?",
    answer: "10"
  },
  {
    id: 36,
    type: "mcq",
    setId: "di3",
    statement: `Five teams — P, Q, R, S and T — played a round-robin football tournament in which every team played every other team exactly once. A win earned 3 points, a draw 1 point and a loss 0 points.
• The final points were: P 7, Q 7, R 5, S 4 and T 4.
• Exactly three matches in the tournament ended in a draw.
• T beat P.
• The match between Q and S ended in a draw.`,
    question: "What was the result of the match between R and T?",
    options: [
      "A. R won",
      "B. T won",
      "C. It was a draw",
      "D. Cannot be determined"
    ],
    answer: "C"
  },
  {
    id: 37,
    type: "tita",
    setId: "di3",
    question: "How many matches did R win?",
    answer: "1"
  },
  {
    id: 38,
    type: "mcq",
    setId: "di3",
    question: "Which teams did Q beat?",
    options: [
      "A. R and T",
      "B. R and S",
      "C. S and T",
      "D. P and R"
    ],
    answer: "A"
  },
  {
    id: 39,
    type: "tita",
    setId: "di3",
    question: "How many teams lost exactly two matches?",
    answer: "2"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    question: "Which team was beaten by S?",
    options: [
      "A. P",
      "B. Q",
      "C. R",
      "D. T"
    ],
    answer: "D"
  },
  {
    id: 41,
    type: "tita",
    setId: "di4",
    statement: `A college has 200 students. Each student may join any of three clubs — Music, Sports and Debate — or none of them.
• Music has 90 members, Sports 100 and Debate 70.
• 50 students belong to exactly two clubs, and 15 students belong to all three.
• The numbers of students who belong only to Music, only to Sports and only to Debate are in the ratio 7 : 10 : 6.
• 25 students belong to Music and Sports but not Debate.
• The number of students in Sports and Debate but not Music is 5 less than the number in Music and Debate but not Sports.`,
    question: "How many students belong to none of the three clubs?",
    answer: "20"
  },
  {
    id: 42,
    type: "mcq",
    setId: "di4",
    question: "How many students belong only to Sports?",
    options: [
      "A. 40",
      "B. 45",
      "C. 50",
      "D. 60"
    ],
    answer: "C"
  },
  {
    id: 43,
    type: "tita",
    setId: "di4",
    question: "How many students belong only to Debate?",
    answer: "30"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    question: "How many students belong to Music but not to Sports?",
    options: [
      "A. 35",
      "B. 50",
      "C. 65",
      "D. 40"
    ],
    answer: "B"
  },
  {
    id: 45,
    type: "mcq",
    setId: "di4",
    question: "Suppose 10 students who belonged to no club join Debate only, and 5 students who belonged only to Music also join Debate. What percentage of all 200 students would then belong to Debate?",
    options: [
      "A. 40%",
      "B. 42.5%",
      "C. 45%",
      "D. 37.5%"
    ],
    answer: "B"
  },
  {
    id: 46,
    type: "tita",
    setId: "di4",
    question: "How many students belong to Music or Debate (or both) but not to Sports?",
    answer: "80"
  }
];

export default catMock3Dilr;
